module.exports = __webpack_public_path__ + "img/Picture2.370d00cd.jpg";